export default __webpack_public_path__ + "static/media/Ente.a5452ce2.png";